import { EFontFamily } from '@NGComponents/NGText/NGText.enum';
import { addTransition } from '@NGUtils/functions';
import styled, { css } from 'styled-components';

export const StyledNGRadioButton = styled.button<{ isActive?: boolean; isDisabled?: boolean }>`
	${(p) => css`
		position: relative;

		display: flex;
		align-items: center;

		background-color: transparent;
		border: none;

		font-family: ${EFontFamily.lato};

		padding-left: 24px;

		&:nth-last-child(1) {
			padding-left: 0;
		}

		cursor: pointer;

		color: ${p.theme.colors.text.darkGold};

		${addTransition()}

		@media (hover: hover) {
			&:hover {
				opacity: 0.7;
			}
		}

		&::before {
			content: ' ';
			position: absolute;
			left: 0;

			width: 15px;
			height: 15px;

			border-radius: 50%;

			border: 2px solid ${p.theme.colors.darkGold};
		}

		&::after {
			content: ' ';
			position: absolute;
			left: 3px;

			width: 9px;
			height: 9px;

			border-radius: 50%;

			background-color: ${p.theme.colors.gold};

			${addTransition()}
			transform: scale(0);
		}

		${p.isActive
			? css`
					&::after {
						transform: scale(1);
					}
			  `
			: ''}
	`}

	${(p) =>
		p.isDisabled
			? css`
					opacity: 0.5;
					cursor: default;

					@media (hover: hover) {
						&:hover {
							opacity: 0.5;
						}
					}
			  `
			: ''}
`;
